<template>
  <div>
    <!-- start, navegación mediante genero principal y secundario -->
    <div v-show="withFilters && genresMain.length > 0">
      <!-- start, aca agregamos componente para genero principal -->
      <div
        style="background-color: #393839; position: relative; display: flex"
        class="w-100 justify-around items-center ttu"
      >
        <!-- boton de navegacion izquierdo -->
        <div>
          <a
            style="margin-left: 10px; fill: white; cursor: pointer"
            v-on:click="genTranslate('genMain', 'left')"
          >
            <svg
              width="25"
              height="25"
              class="bi bi-caret-left"
              viewBox="0 0 16 16"
            >
              <path
                d="M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"
              />
            </svg>
          </a>
        </div>

        <div></div>

        <div class="container-scroll w-100">
          <div id="genMain" class="container-genbar">
            <!-- show genero principal TODOS -->
            <a
              class="genre-filter f6 link dim ph3 pv2 dib white mr2"
              :class="{
                'genre-filter-selected': genreFilter == '',
                pointer: genreFilter != '',
              }"
              @click="selectGenMain('')"
            >
              {{ $t("tracks.genres.all") }}
            </a>

            <!-- show genero principal -->
            <a
              v-show="genresMain.length > 0"
              class="genre-filter f6 link dim ph3 pv2 dib white mr2"
              v-for="genre in genresMain"
              :track-by="genre.id"
              :key="genre.id"
              :tabindex="genre.id"
              :class="{
                'genre-filter-selected': genreFilter == genre.id,
                pointer: genreFilter != genre.id,
              }"
              @click="selectGenMain(genre.id)"
              @blur="selectGenMainBlur($event)"
              @focus="selectGenMainFocus($event)"
            >
              {{ genre.name }}
            </a>
          </div>
        </div>

        <!-- boton de navegacion derecho -->
        <div>
          <a
            style="margin-right: 10px; fill: white; cursor: pointer"
            v-on:click="genTranslate('genMain', 'right')"
          >
            <svg
              width="25"
              height="25"
              class="bi bi-caret-right"
              viewBox="0 0 16 16"
            >
              <path
                d="M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"
              />
            </svg>
          </a>
        </div>
      </div>
      <!-- end, aca agregamos componente para genero principal -->

      <!-- start, aca agregamos componente para genero secundario -->
      <div
        style="background-color: black; position: relative; display: flex"
        class="w-100 justify-between items-center ttu black"
      >
        <!-- boton de navegacion izquierdo -->
        <div>
          <a
            style="fill: white; cursor: pointer"
            v-on:click="genTranslate('genSecon', 'left')"
          >
            <svg
              width="25"
              height="25"
              class="bi bi-caret-left"
              viewBox="0 0 16 16"
            >
              <path
                d="M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"
              />
            </svg>
          </a>
        </div>

        <div class="container-scroll w-100">
          <div id="genSecon" class="container-genbar">

            <!-- show genero secundario -->
            <a
              class="genre-filter f6 link dim ph3 pv2 dib white mr2"
              style="font-size: 0.775rem; min-width: 120px; text-align: center;"
              v-for="genre in genSeconByMain"
              :track-by="genre.id"
              :key="genre.id"
              :class="{
                'genre-filter-selected': genreFilter == genre.id,
                pointer: genreFilter != genre.id,
              }"
              @click="selectGenSecon(genre.id)"
            >
              {{ genre.name }}
            </a>
          </div>
        </div>

        <!-- boton de navegacion derecho -->
        <div>
          <a
            style="fill: white; cursor: pointer"
            v-on:click="genTranslate('genSecon', 'right')"
          >
            <svg
              width="25"
              height="25"
              class="bi bi-caret-right"
              viewBox="0 0 16 16"
            >
              <path
                d="M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"
              />
            </svg>
          </a>
        </div>
      </div>
      <!-- end, aca agregamos componente para genero secundario -->
    </div>
    <!-- start, Filtro por texto -->
    <div v-if="!profileTracks" class="w-100 w-mobile mb-5">
      <div class="search-wrapper w-50-m w-100 block pointer z-1 relative bg-tertiary fr mt3">
        <button class="pointer btn1 dim b f5 fw4" :class="{'w-10': this.mobileWidth}" type="button" icon="search" @click="update"><font-awesome-icon class="search-left-icon " icon="search"/></button>
        <input class="pa2 input bg-transparent w-50-mobile"
                :class="{'w-100': !this.mobileWidth, 'w-80': this.mobileWidth}"
                v-model="textToFilter"
                maxlength="255"
                @keyup.esc="clearFilters"
                @keyup.enter="update"
                :placeholder="$t('artists.search.placeholder')"/>
      </div>
    </div>
    <!-- end, Filtro por texto -->

    <!-- Leyenda de filtros -->
    <div v-if="!profileTracks" class="filtersLabelsDiv">
      <router-link class="filtersLinks"
                   :title="$t('app.discover')"
                   :to="{name:'discover'}">
        <span class="filtersLabels">Tracks</span>
      </router-link>
      <span v-if="mainGenre.name || seconGenre.name || filteredText" @click="filterByMainGenreLabel"> - </span>
      <span v-if="mainGenre.name" class="filtersLabels" @click="filterByMainGenreLabel">{{mainGenre.name}}</span>
      <span v-if="mainGenre.name && seconGenre.name"> / </span>
      <span v-if="seconGenre.name" class="filtersLabels" @click="removeSeconGenreLabel">{{seconGenre.name}}</span>
      <span v-if="(mainGenre.name || seconGenre.name) && filteredText"> / </span>
      <span v-if="filteredText" class="filtersLabels mobileLabelsPosition" @click="removeFilteredTextLabel">{{filteredText}}</span>
    </div>
    <!-- Fin leyenda de filtros -->

    <!-- start, div que encierra el scrolling solo asociado a los tracks -->
    <div
      class="track-list pa1 pb3-ns pt3-ns ph5-l ph3-m"
      :class="{ 'overflow-y-scroll': withPagination }"
      v-infinite-scroll="nextPage"
      infinite-scroll-immediate-check="false"
      infinite-scroll-distance="50"
      infinite-scroll-disabled="disablePagination"
    >
      <div class="track-list-header h2 w-95 mb1 textColor">
        <p class="fl w-10 h-100 ma0 textColor"></p>
        <p
          class="
            fl
            w-30
            h-100
            pa1
            pl3
            ma0
            text-ellipsis
            center-content
            b
            textColor
          "
        >
          {{ $t("tracks.headers.title") }}
        </p>
        <p
          class="
            fl
            w-20
            h-100
            pa1
            pl3
            ma0
            text-ellipsis
            center-content
            b
            textColor
          "
        >
          {{ $t("tracks.headers.artist") }}
        </p>
        <p
          class="
            fl
            w-20
            h-100
            pa1
            pl3
            ma0
            text-ellipsis
            center-content
            b
            textColor
          "
        >
          {{ $t("tracks.headers.genre") }}
        </p>
        <p class="released fl w-15 h-100 pa1 ma0 center-content b textColor">
          {{ $t("tracks.headers.duration") }}
        </p>
        <p class="fl w-5 h-100 ma0"></p>
      </div>
      <div v-show="loading" class="flex justify-center items-center w-100">
        <clip-loader
          :loading="loading"
          :color="color"
          :size="size2"
        ></clip-loader>
      </div>
      <div
        v-show="!tracks"
        class="flex justify-center items-center w-100 noResults textColor"
      >
        {{ $t("app.info.noResults") }}
      </div>
      <div
        v-show="tracks && !loading"
        class="track-container relative mb2"
        v-for="track in tracks"
        :track-by="track.id"
        :key="track.id"
        :class="{ 'track-playing': track == currentTrack }"
      >
        <track-item-list
          :track="track"
          :profileTracks="profileTracks"
          @play="setPlaylist(tracks)"
          class="item-container"
        ></track-item-list>
      </div>
      <div
        v-show="withPagination && noMoreResults"
        class="flex justify-center items-center w-100 pt2 pb2 textColor"
      >
        {{ $t("app.info.noMoreResults") }}
      </div>
      <div
        v-show="withPagination && loadingMore"
        class="flex justify-center items-center w-100"
      >
        <clip-loader
          :loading="loadingMore"
          :color="color"
          :size="size2"
        ></clip-loader>
      </div>
    </div>
    <!-- end, div que encierra el scrolling solo asociado a los tracks -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TrackItemList from './TrackItemList.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import infiniteScroll from 'vue-infinite-scroll'
import debounce from 'debounce'

export default {
  name: 'tracks-list',
  props: {
    tracks: {
      required: true
    },
    withFilters: {
      default: true
    },
    withPagination: {
      default: true
    },
    loading: {
      required: true
    },
    showGenMain: {
      default: true
    },
    showGenSecon: {
      default: true
    },
    profileTracks: {
      default: false
    }
  },
  components: {
    ClipLoader,
    TrackItemList
  },
  directives: {
    infiniteScroll
  },
  data () {
    return {
      color: '#808080',
      size1: '100px',
      size2: '30px',
      disablePagination: false,
      genSeconByMain: [],
      genMainTranslatePosition: 0,
      genSeconTranslatePosition: 0,
      hasSelectedGenMain: false,
      hasSelectedGenSecon: false,
      genMainLastEvent: { // emazzu, para mantener el color de padre seleccionado
        event: null,
        background: null,
        color: null
      },
      busy: false,
      translatePosition: null,
      textToFilter: '',
      selectedGenre: null,
      discoverSelectedGenre: null,
      mobileWidth: false,
      mainGenre: {
        name: null,
        id: null
      },
      seconGenre: {
        name: null,
        id: null
      },
      filteredText: null
    }
  },
  created () {
    this.discoverSelectedGenre = this.genreFilter
    if (this.discoverMainGenre && this.discoverMainGenre.name !== null) {
      this.mainGenre = this.discoverMainGenre
    }
    if (this.discoverSeconGenre && this.discoverSeconGenre.name !== null) {
      this.seconGenre = this.discoverSeconGenre
    }
    this.selectedGenre = this.genreFilter
    this.disablePagination = !this.withPagination
    if (this.withFilters) {
      if (this.discoverSelectedGenre !== null) {
        this.getGenresMain(true)
        this.setGenreFilter(this.discoverSelectedGenre)
      } else {
        this.getGenresMain(true)
        this.setGenreFilter(0)
      }
    }
    window.innerWidth <= 360 ? this.mobileWidth = true : this.mobileWidth = false
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  methods: {
    ...mapActions('track', [
      'getGenresMain',
      'setGenreFilter',
      'getAll',
      'loadMore',
      'setFrom'
    ]),
    ...mapActions('player', ['setPlaylist']),

    clearFilters () {
      this.textToFilter = ''
      this.filteredText = null
    },

    update: debounce(function (e) {
      if (this.textToFilter !== '') {
        this.busy = true
        this.filteredText = this.textToFilter
        this.selectTrackByFilter(this.selectedGenre, this.textToFilter)
        this.busy = false
        this.textToFilter = ''
      } else {
        this.selectTrackByFilter(this.selectedGenre, null)
        this.filteredText = null
      }
    }, 1000, true),

    selectTrackByFilter (selectedId = 0, textToFilter = null) {
      this.setGenreFilter(selectedId)
      this.setFrom(0)
      this.getAll(textToFilter).catch((e) => {
        this.$toasted.show(this.error.message, { type: 'error' })
      })
    },

    // emazzu, start, para mantener el color de seleccion en el genero padre
    selectGenMainBlur (event) {
      this.genMainLastEvent = {
        background: event.target.style.background,
        color: event.target.style.color,
        event: event
      }
      event.target.style.background = '#E6007E'
      event.target.style.color = 'white'
    },

    selectGenMainFocus (event) {
      if (this.genMainLastEvent.event === null) {
        return
      }

      this.genMainLastEvent.event.target.style.background = this.genMainLastEvent.background
      this.genMainLastEvent.event.target.style.color = this.genMainLastEvent.color
    },
    // emazzu, end, para mantener el color de seleccion en el genero padre

    // emazzu, cuando se hace clic en el genero primario
    selectGenMain (selectedId) {
      if (selectedId === '') {
        if (this.genMainLastEvent && this.genMainLastEvent.event) {
          this.genMainLastEvent.event.target.style.background = ''
          this.genMainLastEvent.event.target.style.color = ''
        }
        selectedId = 0
        this.setGenreFilter(selectedId)
        this.setFrom(0)
        this.getAll().catch((e) => {
          this.$toasted.show(this.error.message, { type: 'error' })
        })
      }
      // selectedId = selectedId || 0
      // emazzu, filter todos los tracks que corresponden al genero primario
      this.selectedGenre = selectedId
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.setGenreFilter(selectedId)
        this.setFrom(0)
        this.getAll().catch((e) => {
          this.$toasted.show(this.error.message, { type: 'error' })
        })
      }

      // emazzu, find genero primario seleccionado
      var found = this.genresMain.find((ele) => ele.id === selectedId)
      if (selectedId !== 0) {
        this.mainGenre = found
      } else {
        this.mainGenre = {
          name: null,
          id: null
        }
      }
      this.seconGenre = {
        name: null,
        id: null
      }
      this.textToFilter = ''
      this.filteredText = null

      // emazzu, si encontro, que siempre va a encontrar, menos si selecciona TODOS
      if (typeof found !== 'undefined') {
        this.genSeconByMain = found.children.sort(function (a, b) {
          if (a.name > b.name) {
            return 1
          }
          if (a.name < b.name) {
            return -1
          }
          // a must be equal to b
          return 0
        })
      } else {
        this.genSeconByMain = []
      }

      // flags
      this.hasSelectedGenMain = true
      this.hasSelectedGenSecon = false

      // flag, si selecciono TODOS, vuelvo para atras uno de los flag
      if (selectedId === '') {
        this.hasSelectedGenMain = false
      }

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true
      this.showGenSecon = true
      // Resetea lo posicion del genSecon
      var style = 'transform: translateX( 0px)'
      this.$el.querySelector('#genSecon').style = style
      this.genSeconTranslatePosition = 0
      this.translatePosition = 0

      return null
    },

    selectGenSecon (selectedId) {
      // emazzu, filter todos los tracks que corresponden al genero primario
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.selectTrackByFilter(selectedId)
      }
      this.selectedGenre = selectedId
      this.textToFilter = ''
      this.filteredText = null
      // flags
      this.hasSelectedGenMain = true
      this.hasSelectedGenSecon = true

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true
      this.showGenSecon = true
      var found = this.genSeconByMain.find((ele) => ele.id === selectedId)
      this.seconGenre = found
      return null
    },
    nextPage () {
      if (!this.preventLoadMore) {
        this.busy = true
        this.loadMore(this.textToFilter).then(() => {
          this.busy = false
        })
      }
    },
    // emazzu, transition genero principal y secundario
    genTranslate (element, arrow) {
      const transitionValue = 120

      if (element === 'genMain') {
        this.genMainTranslatePosition += (arrow === 'left' ? transitionValue : transitionValue * -1)
        this.translatePosition = this.genMainTranslatePosition
      }

      if (element === 'genSecon') {
        this.genSeconTranslatePosition += (arrow === 'left' ? transitionValue : transitionValue * -1)
        this.translatePosition = this.genSeconTranslatePosition
      }

      if (this.translatePosition >= 120) {
        this.translatePosition = 0
        this.genMainTranslatePosition = 0
        this.genSeconTranslatePosition = 0
      }
      if (this.translatePosition <= -(120 * (this.genresMain.length - 1)) && element === 'genMain') {
        this.translatePosition = -(120 * (this.genresMain.length - 1))
        this.genMainTranslatePosition = -(120 * (this.genresMain.length - 1))
        this.genSeconTranslatePosition = 0
      }
      if (this.translatePosition <= -(120 * (this.genSeconByMain.length - 1)) && element === 'genSecon') {
        this.translatePosition = -(120 * (this.genSeconByMain.length - 1))
        this.genMainTranslatePosition = 0
        this.genSeconTranslatePosition = -(120 * (this.genSeconByMain.length - 1))
      }
      var style = 'transform: translateX(' + this.translatePosition.toString() + 'px' + ')'
      this.$el.querySelector('#' + element).style = style
    },

    filterByMainGenreLabel () {
      if (this.genMainLastEvent && this.genMainLastEvent.event) {
        this.genMainLastEvent.event.target.style.background = ''
        this.genMainLastEvent.event.target.style.color = ''
      }
      this.mainGenre = {
        name: null,
        id: null
      }
      this.seconGenre = {
        name: null,
        id: null
      }
      this.genSeconByMain = []
      let text = this.filteredText ? this.filteredText : null
      this.selectedGenre = 0
      this.selectTrackByFilter(0, text)
    },
    removeSeconGenreLabel () {
      this.seconGenre = {
        name: null,
        id: null
      }
      let text = this.filteredText ? this.filteredText : null
      this.selectedGenre = this.mainGenre.id
      this.selectTrackByFilter(this.mainGenre.id, text)
    },
    removeFilteredTextLabel () {
      this.selectTrackByFilter(this.selectedGenre)
      this.clearFilters()
    },
    removeAllLabels () {
      this.selectedGenre = 0
      this.genSeconByMain = []
      if (this.genMainLastEvent && this.genMainLastEvent.event) {
        this.genMainLastEvent.event.target.style.background = ''
        this.genMainLastEvent.event.target.style.color = ''
      }
      this.mainGenre = {
        name: null,
        id: null
      }
      this.seconGenre = {
        name: null,
        id: null
      }
      this.filteredText = null
      if (this.textToFilter === '') {
        this.selectTrackByFilter(0)
      } else {
        this.textToFilter = ''
      }
    }
  },
  computed: {
    ...mapGetters('player', ['currentTrack']),
    ...mapGetters('track', [
      'allTracks',
      'genresMain',
      'genreFilter',
      'noMoreResults',
      'discoverMainGenre',
      'discoverSeconGenre'
    ]),
    loadingMore () {
      return this.$loading.isLoading('track loadMore')
    },
    preventLoadMore () {
      return this.loadingMore || this.noMoreResults || this.busy
    },

    // emazzu, para lista desplegable
    loadingGenresMain () {
      return this.$loading.isLoading('track getGenresMain')
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

.filtersLabelsDiv {
  position: relative;
  padding-left: 20px;
}
.filtersLabels {
  cursor: pointer;
  padding: 2px 10px;
  border: 1px solid #E6007E;
  border-radius: 100px;
  text-transform: uppercase;
}
.filtersLabels:hover {
  border: 1px solid #272727;
  background-color: #E6007E;
  font-weight: bold;
  color: #272727;
}
.filtersLinks {
  text-decoration: none;
  color: #aaa !important;
}

.mb-5 {
  margin-bottom: 5rem;
}

.btn1{
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #272727;
  color: white;
  height: 35px;
  border-width: 0px;
  border-radius: 35px;
}

.search-wrapper{
  max-width: 25rem;
}

input {
  padding-left: 8px;
  border: solid black 1px;
  border-radius: 5px;
  line-height: 1px;
  max-width: 19.75rem;
}

.track-playing {
    background-color: $primary-color !important;
  }

.track-list {
  max-height: $main-height;
  height: min-content;
  margin-top: 20px;
}

.genre-filter {
  -webkit-user-select: none; /* Safari 3.1+ */
  -moz-user-select: none; /* Firefox 2+ */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Standard syntax */
  white-space: nowrap;
}

.noResults {
  padding-top: 80px;
}

.genre-filter-selected {
  background-color: $accent-color;
  color: white;
}
@media (min-width: 600px) {
  .filtersLabelsDiv {
    top: -50px;
  }
}

@media (max-width: 480px) {
  .mobileLabelsPosition {
    position: relative;
    top: 15px;
  }
}

@media (min-width: 320px) {
  .item-container :hover {
    background-color: lightgray !important;
  }

  .track-list {
    max-height: $main-height;
    height: min-content;
  }

  .genre-filter {
    -webkit-user-select: none; /* Safari 3.1+ */
    -moz-user-select: none; /* Firefox 2+ */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Standard syntax */
    white-space: nowrap;
  }

  .genre-filter-selected {
    background-color: darkgray;
    color: black;
  }

  @media (min-width: 769px) {
    .item-container :hover {
      background-color: $primary-color;
    }
    .item-container {
      height: 3rem;
    }
  }

  @media (min-width: 1441px) {
    .track-list {
      padding-left: 10rem;
      padding-right: 10rem;
    }
  }

  @media (max-width: 769px) {
    .track-list-header {
      display: none;
    }
    .track-list {
      display: flex;
      flex-wrap: wrap;
    }
    .track-container {
      height: 6rem;
      width: 45%;
      margin: 2.5%;
    }
    .genre-filter {
      padding: 4px;
    }
  }

  @media (max-width: 600px) {
    .track-container {
      width: 95%;
    }
  }

  .container-scroll {
    overflow-x: scroll;
    scroll-behavior: smooth;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .container-genbar {
    display: flex;
    transition: all 0.3s ease-out;
  }

    // como personalizar el scrolling
    // https://css-tricks.com/custom-scrollbars-in-webkit/
    //
  .container-scroll::-webkit-scrollbar {
    display: none;
    scroll-behavior: smooth;
    height: 7px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tracks/TracksList.vue